<template>
  <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#324157" text-color="#bfcbd9"
    active-text-color="#25a0e4" :collapse="isCollapse" :router="routerOpen" ref="elMenu">
    <el-menu-item :index="item.path"
      v-for="(item, index) in routes" :key="item.path + index"
      :style="{display: (item?.meta?.permission?.includes(info?.type) && !(item?.meta?.notPermission?.includes(info?.type)))  ? '' : 'none' }"
      >
      <i :class="item.meta.icon"></i>
      <span slot="title">{{ item.name }}</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapState } from "vuex";
import {routes} from "@/router/index"
export default {
  props: ["isCollapse"],
  data() {
    return {
      routerOpen: true,
      routes: []
    };
  },
  methods: {
    // 判断用户权限是否足够
    auth() { },
  },
  mounted() {
    this.routes = routes.filter(e=>{
      return !(e.path == '/' || e.path == '/login' || e.path == '/404' || e.path == '/403' || e.path == '*')
    })
  },
  computed: {
    ...mapState("user", ["info"]),
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
}

.el-menu {
  border-right: none !important;
}
</style>
